<div class="row" *ngIf="form && selectedDeliveryLocation">
  <div class="col-12">
    <div class="form-group">
      <label for="deliveryLocation" class="control-label" translate>DELIVERY_LOCATION</label>
      <select name="deliveryLocation" id="deliveryLocation" class="form-control form-select" [(ngModel)]="deliveryLocationId">
        <option [value]="option.id" *ngFor="let option of deliveryLocations">
          {{ option.name }}
        </option>
      </select>
    </div>
  </div>

  <div class="col-12 col-md-6">
    <div class="form-group" [formGroup]="form">
      <label for="ordlevadr1" class="control-label" translate>OH_ORDLEVADR1</label>
      <input class="form-control" type="text" name="ordlevadr1" id="ordlevadr1" [formControlName]="'ordlevadr1'" />
    </div>
    <div class="form-group" [formGroup]="form">
      <label for="ordlevadr2" class="control-label" translate>OH_ORDLEVADR2</label>
      <input class="form-control" type="text" name="ordlevadr2" id="ordlevadr2" [formControlName]="'ordlevadr2'" />
    </div>
    <div class="form-group" [formGroup]="form">
      <label for="ordlevadr3" class="control-label" translate>OH_ORDLEVADR3</label>
      <input class="form-control" type="text" name="ordlevadr3" id="ordlevadr3" [formControlName]="'ordlevadr3'" />
    </div>
    <div class="form-group" [formGroup]="formOh">
      <label for="edit" class="control-label w-100" translate>OH_EDITEXT</label>
      <textarea id="edit" name="edit" class="form-control w-100" formControlName="edit" rows="9" cols="50"></textarea>
    </div>
  </div>
  <div class="col-12 col-md-6">
    <div class="form-group">
      <label for="postalCode" class="control-label" translate>OH_FTGPOSTNR</label>
      <input
        class="form-control"
        type="text"
        name="postalCode"
        id="postalCode"
        [(ngModel)]="postalCode"
        [readonly]="isUser"
      />
    </div>
    <div class="form-group">
      <label for="city" class="control-label" translate>OH_ORDLEVADR4</label>
      <input class="form-control" type="text" name="city" id="city" [(ngModel)]="city" [readonly]="isUser" />
    </div>
    <div [formGroup]="form">
      <lib-meta-select-input formControlName="ordlevadrlandskod" table="xr" metaId="landskod" metaDisplay="land">
      </lib-meta-select-input>
    </div>
    <div [formGroup]="form" class="form-group">
      <label for="dp" class="control-label">{{ 'DISPATCH_DATE' | translate }}</label>
      <div class="input-group">
        <input
          class="form-control"
          placeholder="yyyy-mm-dd"
          name="dp"
          ngbDatepicker
          readonly
          [value]="checkout.extra.oh.ordberlevdat"
        />
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div
      *ngIf="alertMessage"
      class="alert mt-2 text-center"
      role="alert"
      [ngClass]="{ 'alert-success': alertMessage.type === 'success', 'alert-danger': alertMessage.type === 'danger' }"
      (click)="alertMessage = null"
    >
      <span>{{ alertMessage.message | translate }}</span>
    </div>
  </div>
</div>
